/* istanbul ignore file */
import { service, factories, Report } from "powerbi-client";
import { REPORT_CLASS_NAME } from "./embeddingConfig";

/**
 * Return active powerbi report instance if exists
 * @returns Report or null
 */
export const getReport = (reportId?: string) => {
  const reports = getAllReports();

  if (!reports || !reports.length) {
    return null;
  }

  if (reportId) {
    return (
      reports.filter((report) => report.getId() === reportId)?.pop() || null
    );
  }

  return reports?.pop() || null;
};

/**
 * Return active powerbi report instance if exists
 * @returns Report or null
 */
export const getAllReports = () => {
  const reportContainers = document.getElementsByClassName(REPORT_CLASS_NAME);
  const activeReportContainers = Array.from(reportContainers) as HTMLElement[];
  if (!activeReportContainers.length) {
    return null;
  }
  const powerBi = new service.Service(
    factories.hpmFactory,
    factories.wpmpFactory,
    factories.routerFactory
  );
  return activeReportContainers.map(
    (element) => powerBi.get(element) as unknown as Report
  );
};
